import '../dev/js/main.js';
import '../dev/scss/index.scss';

import { createApp } from 'vue';

import FeaturedElement from '@/elements/Featured.vue';
import FilterElement from '@/elements/Filters.vue';

import BookingPage from '@/elements/booking/Wrapper.vue';

import IndexPage from '@/elements/location/Index.vue';
import ShowPage from '@/elements/location/Show.vue';

const app = createApp({
  components: {
    FilterElement,
    IndexPage,
    ShowPage,
    BookingPage,
    FeaturedElement,
  },

  setup() {
    return {};
  },
});

app.mount('#page');
